





































import { Component, Prop, Vue } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import { PaymentInfoModel } from '@/app/shared/models';
import ContentPaymentInfo from '@/app/shared/components/contents/payment-info.vue';
@Component({ components: { ContentPaymentInfo } })
export default class ContentPaymentComponent extends Vue {
  @Prop(Object) readonly paymentInfo1!: PaymentInfoModel;
  @Prop(Object) readonly paymentInfo2!: PaymentInfoModel;

  private get refs() {
    return refsService;
  }
  private get document1() {
    return this.paymentInfo1.DocumentType && this.paymentInfo1.Document
      ? `${this.paymentInfo1.DocumentType} - ${this.paymentInfo1.Document}`
      : undefined;
  }
  private get document2() {
    return this.paymentInfo2.DocumentType && this.paymentInfo2.Document
      ? `${this.paymentInfo2.DocumentType} - ${this.paymentInfo2.Document}`
      : undefined;
  }
}
